import { SearchResultStatistics } from './search-result-statistics';

export class HitPager {
  public numberOfHits: number;
  public hitsPerPage: number;
  public numberOfPages: number;
  public currentPageIndex: number;
  public pages: number[];
  public pagesPerGroup = 10;
  public currentGroupIndex = 0;

  public update(stats: SearchResultStatistics): void {
    this.numberOfHits = stats.numberOfHits;
    this.hitsPerPage = stats.numberOfHits;
    this.numberOfPages = stats.numberOfPages;
    this.currentPageIndex = stats.page;
    this.currentGroupIndex = Math.floor(this.currentPageIndex / this.pagesPerGroup);
    this.pages = [];

    for (let i = 0; i < this.numberOfPages; i++) {
      this.pages.push(i);
    }
  }

  public getPageBounds() {
    const startIndex = this.currentPageIndex * this.hitsPerPage;
    let endIndex = startIndex + this.hitsPerPage;

    if (endIndex > this.numberOfHits - 1) {
      endIndex = this.numberOfHits;
    }

    return {
      start: startIndex,
      end: endIndex
    };
  }
}
